export const buildGridifySearchParams = (paramsObj: Record<string, any>) => {
  const params = new URLSearchParams();

  Object.entries(paramsObj).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    if (Array.isArray(value)) {
      value.forEach(v => params.append(key, String(v)));
    } else if (typeof value === 'object') {
      Object.entries(value).forEach(([subKey, subVal]) => {
        if (subVal !== undefined && subVal !== null) {
          params.append(subKey, String(subVal));
        }
      });
    } else {
      params.append(key, String(value));
    }
  });

  return params.toString();
};
